import { selectBuildingDecorationConstructionDone } from "../selectors/selectBuildingDecorationConstructionDone";
export var checkAnyDecorationConstructionDoneAvailable = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var availableDecorationBuildings = selectBuildingDecorationConstructionDone(state);
    return availableDecorationBuildings.length !== 0 ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyDecorationConstructionDoneAvailable.ts
// module id = 2367
// module chunks = 3